import { useContext } from 'react';
import { SocketContext } from '../../context/SocketContext/context';

function useSocket() {
  return useContext(SocketContext);
}

export default useSocket;
